const separateColor = () => {
  const color_swatches = Array.from(
    document.querySelectorAll(".variant-option__button-label--has-swatch")
  );
  const saleSegment = document.querySelector("#saleSegment");
  const secretSaleSegment = document.querySelector("#secretSaleSegment");
  const seasonalSegment = document.querySelector("#seasonalSegment");
  const normalSegment = document.querySelector("#normalSegment");
  const collaboSegment = document.querySelector("#collaboSegment");
  const campaignSegment = document.querySelector("#campaignSegment");
  const parentWrapper = document.querySelector(".variant-option--swatches");
  if(!parentWrapper) return;
  parentWrapper.classList.add("is-reordering");

  if (color_swatches) {
    if (saleSegment && normalSegment && seasonalSegment && parentWrapper && collaboSegment && secretSaleSegment) {
      parentWrapper.style.flexDirection = "column";
      color_swatches.forEach((element) => {
        if (element.querySelector(".color-swatch").dataset.isNormalSale == "true") {
          saleSegment.appendChild(element);
          saleSegment.parentElement.style.opacity = "1";
        } else if (element.querySelector(".color-swatch").dataset.isSecretSale == "true") {
          secretSaleSegment.appendChild(element);
          secretSaleSegment.parentElement.style.opacity = "1";
        } else if (element.querySelector(".color-swatch").dataset.isCollabo == "true") {
          collaboSegment.appendChild(element);
          collaboSegment.parentElement.style.opacity = "1";
        } else if (element.querySelector(".color-swatch").dataset.isCampaign == "true") {
          campaignSegment.appendChild(element);
          campaignSegment.parentElement.style.opacity = "1";
        } else if (element.querySelector(".color-swatch").dataset.isSeasonal == "true") {
          seasonalSegment.appendChild(element);
          seasonalSegment.parentElement.style.opacity = "1";
        } else {
          normalSegment.appendChild(element);
          normalSegment.parentElement.style.opacity = "1";
        }
      });
    }
  }

  if (seasonalSegment && !seasonalSegment.hasChildNodes()) {
    seasonalSegment.parentElement.style.display = "none";
  }
  if (saleSegment && !saleSegment.hasChildNodes()) {
    saleSegment.parentElement.style.display = "none";
  }
  if (secretSaleSegment && !secretSaleSegment.hasChildNodes()) {
    secretSaleSegment.parentElement.style.display = "none";
  }
  if (normalSegment && !normalSegment.hasChildNodes()) {
    normalSegment.parentElement.style.display = "none";
  }
  if (collaboSegment && !collaboSegment.hasChildNodes()) {
    collaboSegment.parentElement.style.display = "none";
  }
  if (campaignSegment && !campaignSegment.hasChildNodes()) {
    campaignSegment.parentElement.style.display = "none";
  }

  
  requestAnimationFrame(() => {
    parentWrapper.classList.remove("is-reordering");
  });
};

document.addEventListener("DOMContentLoaded", () => {
  const variantPicker = document.querySelector("variant-picker");
  if (!variantPicker) return;

  separateColor();

  variantPicker.addEventListener("variant:update", () => {
    separateColor();
  });
});